import * as sessionReplay from '@amplitude/session-replay-browser';

import { AMPLITUDE_API_KEY } from '#src/config.ts';
import { loadCookie } from '#src/lib/cookies.ts';

import {
  SIGNUP_REPLAY_TRIGGER_EVENTS,
  sessionReplayState,
} from './sessionReplayState.ts';

const hasAmplitudeConsent = () => {
  const { destinations } = loadCookie('tracking-preferences2') ?? {};
  return Boolean(
    destinations?.Amplitude || destinations?.['Actions Amplitude']
  );
};

export const maybeStartSessionReplay = (
  event: string,
  flagEnabled: boolean
): void => {
  if (
    !SIGNUP_REPLAY_TRIGGER_EVENTS.has(event) ||
    sessionReplayState.active ||
    !flagEnabled ||
    !hasAmplitudeConsent() ||
    !window.analytics?.user
  ) {
    return;
  }
  const deviceId = window.analytics.user().anonymousId();
  const sessionId = Number(loadCookie('analytics_session_id')) || 0;
  sessionReplay.init(AMPLITUDE_API_KEY, {
    deviceId,
    sessionId,
    sampleRate: 1,
  });
  sessionReplayState.active = true;
};
